import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getSummaryLedgerReport,
  getSummaryNext,
  getSummaryPrevious,
  getSummaryParticularPage,
  getDetailLedgerReport,
  getDetailNext,
  getDetailPrevious,
  getDetailParticularPage,
} from "./thunk";

// initialState
const initialState = {
  ledgerDetails: [],
  ledgerSummaries: [],
  loadingData: false,
  loading: false,
  count: 0,
  pageNo: 1,
  previous: null,
  next: null,
  countDetail: 0,
  previousDetail: null,
  nextDetail: null,
};

//
export const ledgerSlice = createSlice({
  name: "ledger",
  initialState,
  reducers: {
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    clearLedger: (state) => {
      state.loading = false;
    },
  },

  extraReducers: (builder) => {
    builder.addMatcher(
      isAnyOf(
        getSummaryLedgerReport.pending,
        getSummaryParticularPage.pending,
        getSummaryPrevious.pending,
        getSummaryNext.pending
      ),
      (state) => {
        state.loading = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getSummaryLedgerReport.fulfilled,
        getSummaryParticularPage.fulfilled,
        getSummaryPrevious.fulfilled,
        getSummaryNext.fulfilled
      ),
      (state, action) => {
        state.loading = false;
        state.ledgerSummaries = action.payload?.data;
        state.count = action.payload?.totalCount;
        state.previous = action.payload?.previous;
        state.next = action.payload?.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getSummaryLedgerReport.rejected,
        getSummaryParticularPage.rejected,
        getSummaryPrevious.rejected,
        getSummaryNext.rejected
      ),
      (state) => {
        state.loading = false;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getDetailLedgerReport.pending,
        getDetailParticularPage.pending,
        getDetailPrevious.pending,
        getDetailNext.pending
      ),
      (state) => {
        return { ...state, loading: true };
      }
    );
    builder.addMatcher(
      isAnyOf(
        getDetailLedgerReport.fulfilled,
        getDetailParticularPage.fulfilled,
        getDetailPrevious.fulfilled,
        getDetailNext.fulfilled
      ),
      (state, action) => {
        state.loading = false;
        state.ledgerDetails = action.payload.data;
        state.countDetail = action.payload.totalCount;
        state.previousDetail = action.payload.previous;
        state.nextDetail = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getDetailLedgerReport.rejected,
        getDetailParticularPage.rejected,
        getDetailPrevious.rejected,
        getDetailNext.rejected
      ),
      (state) => {
        state.loading = false;
      }
    );
  },
});

export const { goToPage, clearLedger } = ledgerSlice.actions;

export default ledgerSlice.reducer;
